import request from '../utils/request'
// 首页
// 商品分类
export function queryCategoryList () {
  return request({
    url: '/api/app/merchant/product/query_category_list',
    method: 'get'
  })
}
// banner
export function bannerListQuery (data) {
  return request({
    url: '/api/app/banner/bannerListQuery',
    method: 'get',
    params: data
  })
}
// 获取用户信息
export function findLoginMchInfo () {
  return request({
    url: '/api/app/merchant/mchinfo/findLoginMchInfo',
    method: 'get'
  })
}

// 快捷入口
export function quickEntryMain () {
  return request({
    url: '/api/app/quickEntry/main',
    method: 'get'
  })
}
// 促销活动
export function queryAppPromotion () {
  return request({
    url: '/api/app/merchant/product/query_app_promotion',
    method: 'get'
  })
}
// 促销商品
export function promotionSearchList (data) {
  return request({
    url: '/api/app/merchant/product/promotion_search_list',
    method: 'get',
    params: data
  })
}
// 促销方式
export function promotionNameSearch (data) {
  return request({
    url: '/api/app/merchant/product/promotion_name_search',
    method: 'get',
    params: data
  })
}
// 新品上架
export function topUpShelfProductList (data) {
  return request({
    url: '/api/app/merchant/product/top_up_shelf_product_list',
    method: 'get',
    params: data
  })
}
// 热销榜
export function topUpSaleProductList (data) {
  return request({
    url: '/api/app/merchant/product/top_sale_product_list',
    method: 'get',
    params: data
  })
}
// 推荐商品
export function productRecommendPageQuery (data) {
  return request({
    url: '/api/app/recommend/productRecommendPageQuery',
    method: 'get',
    params: data
  })
}
// 快捷入口  api/app/quickEntry/cat

export function cat (data) {
  return request({
    url: 'api/app/quickEntry/cat',
    method: 'get',
    params: data
  })
}
// entryId: 54
// sortWord: shelfTime
export function goods (data) {
  return request({
    url: 'api/app/quickEntry/goods',
    method: 'get',
    params: data
  })
}
// 通栏广告关联多个商品跳转接口
export function bannerProductListQuery (data) {
  return request({
    url: 'api/app/banner/bannerProductListQuery',
    method: 'get',
    params: data
  })
}
